import { Validators } from '@angular/forms';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { NameHelpers } from '@principle-theorem/principle-core';
import {
  IAccInvoiceBuilderClaimData,
  IAccInvoicePatientDetails,
  IAccInvoiceProviderDetails,
  IPatient,
  IPractice,
  IStaffer,
} from '@principle-theorem/principle-core/interfaces';
import { ISODateType, WithRef } from '@principle-theorem/shared';

export class AccExistingClaimFormGroup extends TypedFormGroup<
  Omit<IAccInvoiceBuilderClaimData, 'purchaseOrderNumber'>
> {
  constructor(
    patient: WithRef<IPatient>,
    practice: WithRef<IPractice>,
    staffer?: WithRef<IStaffer>
  ) {
    super({
      claimNumber: new TypedFormControl<string>('', Validators.required),
      accidentDate: new TypedFormControl<ISODateType>(),
      patientDetails: new TypedFormGroup<IAccInvoicePatientDetails>({
        nhi: new TypedFormControl<string>(
          patient.nationalHealthIndexNumber ?? ''
        ),
        dateOfBirth: new TypedFormControl<ISODateType>(patient.dateOfBirth),
        firstName: new TypedFormControl<string>(
          NameHelpers.firstName(patient.name),
          Validators.required
        ),
        middleName: new TypedFormControl<string>(''),
        surname: new TypedFormControl<string>(
          NameHelpers.lastName(patient.name),
          Validators.required
        ),
      }),
      providerDetails: new TypedFormGroup<IAccInvoiceProviderDetails>({
        providerId: new TypedFormControl<string>(
          staffer?.metadata?.nz?.providerDetails.acc?.providerId,
          Validators.required
        ),
        facilityId: new TypedFormControl<string>(
          practice.accSettings?.facilityId
        ),
        firstName: new TypedFormControl<string>(
          NameHelpers.firstName(
            NameHelpers.withoutTitle(staffer?.user.name ?? '')
          ),
          Validators.required
        ),
        middleName: new TypedFormControl<string>(''),
        surname: new TypedFormControl<string>(
          NameHelpers.lastName(
            NameHelpers.withoutTitle(staffer?.user.name ?? '')
          ),
          Validators.required
        ),
      }),
    });
  }
}
